import React from 'react';
import { useAuth } from '../context/AuthContext';
import { XCircle, ShieldOff } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useTranslation } from 'react-i18next';

function InactiveUser() {
  const { t } = useTranslation('inactiveUser');
  const { logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 px-4">
      <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-slate-200 dark:border-slate-700 p-8">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="p-4 bg-red-50 dark:bg-red-900/20 rounded-full">
              <XCircle className="h-16 w-16 text-red-500" />
            </div>
            <div className="absolute -top-1 -right-1 p-1.5 bg-slate-500 rounded-full">
              <ShieldOff className="h-4 w-4 text-white" />
            </div>
          </div>
        </div>
        
        <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 mb-4 text-center" style={{ fontFamily: "'Outfit', -apple-system, 'Segoe UI', Roboto, sans-serif" }}>
          {t('title')}
        </h2>
        
        <div className="space-y-4 mb-6">
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <XCircle className="h-5 w-5 text-red-600 dark:text-red-400 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-red-900 dark:text-red-100 mb-1">
                  {t('notice.title')}
                </p>
                <p className="text-sm text-red-700 dark:text-red-300">
                  {t('notice.text')}
                </p>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 dark:bg-slate-900/50 rounded-lg p-4">
            <p className="text-sm text-slate-600 dark:text-slate-400 text-center">
              {t('contact')}
            </p>
          </div>
        </div>
        
        <Button onClick={logout} variant="outline" className="w-full" data-testid="inactive-logout-btn">
          {t('backToLogin')}
        </Button>
      </div>
    </div>
  );
}

export default InactiveUser;
